<div class="sh-page-header">
  @if ((primaryNavigationItems && primaryNavigationItems.length) || (secondaryNavigationItems && secondaryNavigationItems.length)) {
    <nav
      class="sh-page-header__navigation"
      >
      <div class="sh-action-bar">
        @if (primaryNavigationItems && primaryNavigationItems.length) {
          <div class="sh-action-bar__group -sh-item-gap -sh-align-left">
            @for (navigationItem of primaryNavigationItems; track navigationItem) {
              <sh-icon-link [item]="navigationItem" class="sh-action-bar__group__item"></sh-icon-link>
            }
          </div>
        }
        @if (secondaryNavigationItems && secondaryNavigationItems.length) {
          <div class="sh-action-bar__group -sh-item-gap">
            @for (navigationItem of secondaryNavigationItems; track navigationItem) {
              <sh-icon-link [item]="navigationItem" class="sh-action-bar__group__item"></sh-icon-link>
            }
          </div>
        }
      </div>
    </nav>
  }

  <header class="sh-page-header__head">
    <div class="sh-page-header__head__info">
      <div class="sh-page-header__head__info__title">
        <ng-content select="[shPageHeaderLead]"></ng-content>
        @if (!isSubsection) {
          <h2 class="sh-page-title" [class.sh-icon-title]="icon">
            @if (icon) {
              <svg sh-icon class="sh-icon-title__icon" [size]="iconSize.LARGE" aria-hidden="true" [name]="icon"></svg>
            }
            {{ title }}
          </h2>
        }
        @if (isSubsection) {
          <h3 class="sh-page-title--subsection" [class.sh-icon-title]="icon">
            @if (icon) {
              <svg sh-icon class="sh-icon-title__icon" [size]="iconSize.REGULAR" aria-hidden="true" [name]="icon"></svg>
            }
            {{ title }}
          </h3>
        }

        @if (contextItems && contextItems.length) {
          <div class="sh-page-header__head__info__context">
            <sh-inline-description-list [items]="contextItems" [fullWidth]="fullWithContext"></sh-inline-description-list>
          </div>
        }
      </div>
    </div>
    @if (actionItems && actionItems.length) {
      <div class="sh-page-header__head__actions">
        <div class="sh-action-group -sh-condense">
          @for (item of actionItems; track item) {
            <sh-action-item [item]="item" class="sh-action-group__item"></sh-action-item>
          }
        </div>
      </div>
    }
  </header>
</div>
